"use strict";

import $ from "jquery";

var runOnResize = debounce(runOnResizeFnc, 250),
    runOnScroll = debounce(runOnScrollFnc, 15),
    viewportWidth,
    viewportHeight,
    htmlTop;
// asideItemsAreOnScreenCanRun = true,
// asideEl,
// asideAEl

(function () {
    // asideEl = document.getElementById('aside');
    // if (asideEl) {
    // 	asideAEl = asideEl.querySelectorAll('ul a');
    // 	asideEl.scrollTop = 0;
    // }

    window.addEventListener("resize", runOnResize);
    runOnResizeFnc();

    window.addEventListener("scroll", runOnScroll);
    setTimeout(runOnScrollFnc, 100);

    configMailtoLink();

    configSidebar();

    linksConfig();
})();

function debounce(func, wait, immediate) {
    "use strict";

    var timeout;

    return function () {
        var context = this,
            args = arguments,
            later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            },
            callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}

function runOnResizeFnc() {
    "use strict";

    viewportWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
    );
    viewportHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
    );

    // if (Math.abs(viewportHeight - viewportHeightMax) < 50) {
    // 	viewportHeight = Math.min(viewportHeightMax, viewportHeight);
    // }
    // viewportHeightMax = viewportHeight;

    runOnScroll();
}

function runOnScrollFnc() {
    htmlTop =
        (window.pageYOffset || document.documentElement.scrollTop) -
        (document.documentElement.clientTop || 0);

    // var els = document.querySelectorAll('.sticky');
    // for (let i = 0; i < els.length; i++) {
    // 	const el = els[i],
    // 		isFixed = el.classList.contains('is-fixed');

    // 	if (isFixed) {
    // 		if (htmlTop < el.parentNode.offsetTop) {
    // 			el.classList.remove('is-fixed');
    // 			asideEl.scrollTop = 0;
    // 		}
    // 	} else {
    // 		if (htmlTop > el.offsetTop) {
    // 			el.classList.add('is-fixed');
    // 		}
    // 	}
    // }

    // asideItemsAreOnScreen();

    var a = htmlTop / viewportHeight,
        b = a > 0.9,
        el = document.getElementById("main");

    // if (b) {
    // 	el.classList.add('on-screen');
    // } else {
    // 	el.classList.remove('on-screen');
    // }

    // if (el && animateIntro) {
    // 	animateIntro();
    // }

    // htmlTopPrev = htmlTop;

    // htmlTopPrev = htmlTop;
}

var animateIntro = function () {
    animateIntro = null;

    if (htmlTop < 1.9 * viewportHeight) {
        setTimeout(() => {
            $("html,body").animate(
                {
                    scrollTop: $("#main").offset().top,
                },
                1200
            );
        }, 800);
    }
};

function configMailtoLink() {
    var items = document.querySelectorAll('a[href^="mailto:"]');

    function replace(text) {
        return text.replace(" [arroba] ", "@").replace(" [ponto] ", ".");
    }

    for (var i = 0, len = items.length; i < len; i++) {
        items[i].setAttribute("href", replace(items[i].getAttribute("href")));
        items[i].innerHTML = replace(items[i].innerHTML);
    }
}

function linksConfig() {
    var els = document.querySelectorAll('a[href^="#"]');

    for (let i = 0; i < els.length; i++) {
        const el = els[i];
        els[i].addEventListener("click", linksInternalOnClick);
    }

    var els = document.querySelectorAll(
        'a:not([href^="#"]):not([rel="noopener"]):not([href^="' +
            jprVars.homeUrl +
            '"])'
    );

    for (let i = 0; i < els.length; i++) {
        const el = els[i];
        el.setAttribute("rel", "noopener");
    }
}

function linksInternalOnClick(e) {
    e.preventDefault();

    var aEl = e.target;

    while (aEl.tagName != "A") {
        aEl = aEl.parentNode;
    }

    const liEl = aEl.parentNode;
    const href = aEl.getAttribute("href");
    const targetId = href.substr(href.indexOf("#") + 1);

    if (!targetId) {
        return;
    }

    const target = document.getElementById(targetId);

    if (!target) {
        return;
    }

    const $target = $(target);
    // targetIsCidades = target.getAttribute('id') == 'cidades';

    var $wrap = $target.find("[ui-accordion]:first-of-type:not(.is-showing)"),
        scrolltop;

    if (!$wrap.length) {
        $wrap = $target.parents("[ui-accordion]:not(.is-showing)");
    }

    if ($wrap.length) {
        var $wrapTrg = $wrap.find("[ui-accordion-trg]:first");
    }

    const animateDuration = 1000;

    // asideItemsAreOnScreenCanRun = false;

    // asidePositionByEl(liEl);

    if ($wrapTrg && $wrapTrg.length) {
        $wrapTrg.trigger("click");
        setTimeout(() => {
            scrolltop = $target.offset().top; // - 11
            $("html,body").animate(
                {
                    scrollTop: scrolltop,
                },
                animateDuration,
                linksInternalAfterScroll
            );
        }, 400);
    } else {
        scrolltop = $target.offset().top;

        // if (!targetIsCidades) {
        // 	scrolltop -= 11;
        // }

        $("html,body").animate(
            {
                scrollTop: scrolltop,
            },
            animateDuration,
            linksInternalAfterScroll
        );
    }
}

// function asideSetOnScreenOnEl(liEl, active) {

// 	if (liEl.classList.contains('on-screen')) {
// 		return;
// 	}

// 	asideClearOnScreen();

// 	liEl.parentNode.classList.add('has-on-screen');
// 	liEl.classList.add('on-screen');

// }

// function asidePositionByEl(liEl) {

// 	asideSetOnScreenOnEl(liEl);

// 	if (liEl.parentNode.classList.contains('artisans')) {
// 		$(asideEl).stop().animate({
// 			scrollTop: liEl.offsetTop - 0.4 * viewportHeight
// 		}, 400);
// 	}

// }

// function asideClearOnScreen() {

// 	const toRemove = asideEl.querySelector('.on-screen');
// 	if (toRemove) {
// 		toRemove.classList.remove('on-screen');
// 		toRemove.parentNode.classList.remove('has-on-screen');
// 	}

// }

function linksInternalAfterScroll() {
    // 	asideItemsAreOnScreenCanRun = true;
}

// function asideItemsAreOnScreen() {

// 	if (!asideItemsAreOnScreenCanRun) {
// 		return;
// 	}

// 	for (var i = 0; i < asideAEl.length; i++) {
// 		const aEl = asideAEl[i],
// 			liEl = aEl.parentNode,
// 			href = aEl.getAttribute('href'),
// 			targetId = href.substr(href.indexOf('#') + 1),
// 			targetEl = document.getElementById(targetId);

// 		if (!targetEl) {
// 			continue;
// 		}

// 		const $target = $(targetEl),
// 			parent = targetEl.parentNode,
// 			$parent = $(parent),
// 			vh = 0.8 * viewportHeight,
// 			isSubItem = parent.getAttribute('id') != 'cities';

// 		if (!parent) {
// 			continue;
// 		}

// 		if (!isSubItem) {
// 			var offset = $target.offset(),
// 				top = offset.top - vh,
// 				bottom = offset.top + $target.outerHeight(true) - vh;
// 		} else {
// 			var parentOffset = $parent.offset(),
// 				top = parentOffset.top - vh,
// 				bottom = parentOffset.top + $parent.outerHeight(true) - vh;
// 		}

// 		if (top < htmlTop && bottom > htmlTop) {
// 			asidePositionByEl(liEl);
// 			asideSetOnScreenOnEl(liEl, true);
// 			break;
// 		}
// 	}

// 	if (i == asideAEl.length) {
// 		asideClearOnScreen();
// 	}

// }

function configSidebar() {
    const ul = document.querySelector(".widget-topics--list__topic-text");
    const sections = document.querySelectorAll(".entry-content");

    if (!ul || !sections) {
        return;
    }

    for (const section of sections) {
        const topics = section.querySelectorAll("h1, h2, h3, h4, h5");
        let i = 1;

        for (let topic of topics) {
            const topicText = topic.textContent;

            if (topic.classList.contains("section-team__item__title")) {
                topic = topic.parentNode.parentNode;
            }

            let topicId = topic.getAttribute("id");

            if (!topicId) {
                topicId = `topic-${i}`;
                topic.setAttribute("id", topicId);
            }

            // if (topic.tagName === "H6" && topicText.split(" ").length > 10) {
            //     continue;
            // }

            const liId = `topic-text-${topicId}`
            if (ul.querySelector(`.${liId}`)) {
              continue
            }
            const li = document.createElement("li");
            li.classList.add(liId);
            li.classList.add("topic");
            li.classList.add("topic-text");
            li.classList.add(`topic-text-${topic.tagName.toLowerCase()}`);

            const li_a = document.createElement("a");
            li_a.setAttribute("href", `#${topicId}`);
            li_a.textContent = topicText;

            li.appendChild(li_a);
            ul.appendChild(li);

            i++;
        }
    }
}



// WEBPACK FOOTER //
// ./js/custom.js